module.exports = __webpack_public_path__ + "img/10-ประวัติชำระย้อนหลัง.8690eccd.png";